/** The grid's Kind column: labels and sort order. */

import type { VisitTypesRow } from './useVisitTypesData';

/** Kind labels, in the order the grid sorts them. */
const KIND: Record<string, { label: string; order: number }> = {
  oasis: { label: 'OASIS', order: 0 },
  evaluation: { label: 'Eval', order: 1 },
  routine: { label: 'Routine', order: 2 },
  discharge: { label: 'Discharge', order: 3 },
  supervisory: { label: 'Supervisory', order: 4 },
  care_plan: { label: 'Care Planning', order: 5 },
  visit: { label: 'Visit', order: 6 },
  order: { label: 'Orders', order: 7 },
  communication: { label: 'Comms', order: 8 },
  misc: { label: 'Misc', order: 9 },
};
export const kindOf = (row: VisitTypesRow) =>
  KIND[row.category] ?? { label: row.category, order: 99 };

export const ALL_KINDS: string[] = Object.keys(KIND);
